'use client';

import { useTranslations } from 'next-intl';
import { FC } from 'react';
import { InlineEmpty } from '@/lib/ui-kit/inline-empty';

interface EmptyProps {
  title?: string;
  desc?: string;
}

export const Empty: FC<EmptyProps> = ({ title, desc }) => {
  const t = useTranslations('comments');
  return <InlineEmpty description={desc ?? t('emptyDesc')}>{title ?? t('emptyTitle')}</InlineEmpty>;
};
